import { createElement, styled, composedProps } from '@vebox/etui-system';

const H1Element = createElement('h1');
const H1 = styled(H1Element)(composedProps);

export { H1 };
